import { bootstrapApplication } from '@angular/platform-browser';
import { appConfig } from './app/app.config';
import { App } from './app/app';
import { TranslateService } from '@ngx-translate/core';
import { SeoService } from './app/services/seo/seo.service';
import { Router, NavigationEnd, ActivatedRoute } from '@angular/router';
import { filter, map } from 'rxjs/operators';

bootstrapApplication(App, appConfig)
  .then(appRef => {
    const translate = appRef.injector.get(TranslateService);
    translate.setDefaultLang('ru');
    translate.use('ru');

    // set default SEO tags immediately
    try {
      const seo = appRef.injector.get(SeoService);
      seo.setDefaultTags();
    } catch (e) {
      console.warn('SeoService not available:', e);
    }

    // Listen for router navigation and set per-route meta from route.data
    try {
      const router = appRef.injector.get(Router);
      const seo = appRef.injector.get(SeoService);
      const activatedRoute = appRef.injector.get(ActivatedRoute);

      router.events.pipe(
        filter((event): event is NavigationEnd => event instanceof NavigationEnd),
        map(() => {
          // find deepest activated route
          let route = activatedRoute as ActivatedRoute;
          while (route.firstChild) {
            route = route.firstChild;
          }
          return route.snapshot.data || {};
        })
      ).subscribe((data) => {
        if (data && Object.keys(data).length) {
          seo.setTags({
            title: data['title'],
            description: data['description'],
            url: data['canonical'] || undefined,
            image: data['image'] || undefined,
            siteName: data['siteName'] || undefined,
          });
        } else {
          // restore defaults if route has no data
          seo.setDefaultTags();
        }
      });
    } catch (e) {
      // router or seo not available
      // ignore
    }
  })
  .catch((err) => console.error(err));
